// import { trackEvent as trackUserEvent } from '../../../util/analytics'; // TODO: Create new analytics file

export const COGNITO_ERROR_CODES = {
	USER_NOT_FOUND: 'UserNotFoundException',
	PASSWORD_RESET_REQUIRED: 'PasswordResetRequiredException',
	INTERNAL_ERROR: 'InternalErrorException',
	TOO_MANY_REQUESTS: 'TooManyRequestsException',
	USER_NOT_CONFIRMED: 'UserNotConfirmedException',
	CODE_MISMATCH: 'CodeMismatchException',
	EXPIRED_CODE: 'ExpiredCodeException',
	USERNAME_EXISTS: 'UsernameExistsException',
	INVALID_PASSWORD: 'InvalidPasswordException',
};

export const errorCodes = [
	{
		code: COGNITO_ERROR_CODES.USER_NOT_FOUND,
		message:
			'Email not found. Try a different email address, or create an account if you have never created an account before.',
	},
	{
		code: COGNITO_ERROR_CODES.PASSWORD_RESET_REQUIRED,
		message:
			'A password reset is required for your account. Please reset your password using the Forgot Password feature.',
	},
	{
		code: COGNITO_ERROR_CODES.INTERNAL_ERROR,
		message:
			'There was in internal error processing your request. Please try again later.',
	},
	{
		code: COGNITO_ERROR_CODES.TOO_MANY_REQUESTS,
		message:
			'Request limit for this action has been exceeded. Please try again later.',
	},
	{
		code: COGNITO_ERROR_CODES.USER_NOT_CONFIRMED,
		message:
			"It looks like you haven't confirmed your account yet. Please check your inbox for a confirmation email and click the link in the email to confirm your email address. You may need to check your spam folder.",
	},
	{
		code: COGNITO_ERROR_CODES.CODE_MISMATCH,
		message: 'Invalid verification code provided, please try again.',
	},
	{
		code: COGNITO_ERROR_CODES.EXPIRED_CODE,
		message: 'That code has expired. Please request a new code.',
	},
	{
		code: COGNITO_ERROR_CODES.USERNAME_EXISTS,
		message:
			'An account for that email address already exists. Please sign in to that account, or contact us if you can no longer access it.',
	},
	{
		code: COGNITO_ERROR_CODES.INVALID_PASSWORD,
		message: 'That password is invalid. Please try again.',
	},
];

// eslint-disable-next-line default-param-last
export const trackEvent = async (label, action = 'click', value) => {
	// const category = 'customer_portal';
	// begins purchase flow
	if (['start', 'menu_customize-policy'].includes(label) && typeof window !== 'undefined') {
		// trackUserEvent('quote_start');
	}
	// clicks pay button with intent to buy
	if (label === 'checkout') {
		// trackUserEvent('checkout');
	}
	// successful purchase
	if (label === 'successful-purchase') {
		// trackUserEvent('purchase', {
		// 	id: `payment_${Number(new Date())}`,
		// 	value: `${value}`,
		// 	currency: 'USD',
		// });
	}
	// all events fire here
	// trackUserEvent(label, { action, value, category });
};

export const scrollToTop = (immediately = true) => {
	if (immediately) {
		window.scrollTo(0, 0);
		return null;
	}
	try {
		// trying to use new API - https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	} catch (error) {
		// just a fallback for older browsers
		window.scrollTo(0, 0);
	}
	return null;
};

export const VIEW_PATHS = {
	HOME: 'home',
	PURCHASE: 'customize-policy',
	SETTINGS: 'account',
	CLAIMS: 'claims',
	POST_CHECKOUT: 'thanks',
	HELP: 'help',
	POLICIES: 'policies',
	EDIT_POLICY: 'edit-policy',
	UPDATE_RENEWAL: 'update-renewal',
};

export const BASE_PATH = '/app';
